import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { APP_CONFIG } from '../../tokens/app-config.token';
import { Environment } from '../../../../environments/environment.interface';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SourceType } from '@dn/libs/ui/dn-common';

@Injectable({
  providedIn: 'root',
})
export class ConfigVersionService {
  version = 'latest';
  appSourceName = SourceType.Website;

  constructor(
    private readonly httpService: HttpClient,
    @Inject(APP_CONFIG) private readonly appConfig: Environment,
  ) {}

  checkConfigVersion(): Observable<any> {
    return this.httpService
      .post<any>(`${this.appConfig.config_backend_url}/version`, {
        version: this.version,
        source: this.appSourceName,
      })
      .pipe(
        catchError((e) => throwError(e)),
      );
  }
}
